import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import Assessment from './Assessment.component';
import AssessmentAccessGuard from './AssessmentAccessGuard';

const AssessmentControlPage: React.FC = () => {
  const processTypeStringId = AssessmentSessionProcessTypeId.Control.toString();
  const processTypeId = parseInt(processTypeStringId) as AssessmentSessionProcessTypeId;

  return (
    <AssessmentAccessGuard processTypeStringId={processTypeStringId}>
      <Assessment processTypeId={processTypeId} processTypeStringId={processTypeStringId} />
    </AssessmentAccessGuard>
  );
};

export default AssessmentControlPage;
